import { render, staticRenderFns } from "./MasterQuery.vue?vue&type=template&id=3da895a5&scoped=true&"
import script from "./MasterQuery.vue?vue&type=script&lang=js&"
export * from "./MasterQuery.vue?vue&type=script&lang=js&"
import style0 from "./MasterQuery.vue?vue&type=style&index=0&id=3da895a5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da895a5",
  null
  
)

export default component.exports